import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Mic, Languages, Clapperboard, Megaphone, GraduationCap } from "lucide-react";
import { SERVICES } from "../site/content";
import { EASE } from "./Motion";

const ICONS = {
  transcription: Mic,
  translation: Languages,
  media: Clapperboard,
  advertising: Megaphone,
  learn: GraduationCap,
};

const SPANS = [
  "md:col-span-7",
  "md:col-span-5",
  "md:col-span-4",
  "md:col-span-4",
  "md:col-span-4",
];

export default function ServiceBento() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-12 gap-5 lg:gap-6" data-testid="services-bento-grid">
      {SERVICES.map((s, i) => {
        const Icon = ICONS[s.id];
        return (
          <motion.div
            key={s.id}
            className={SPANS[i]}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.7, ease: EASE, delay: i * 0.08 }}
          >
            <Link
              to={s.link}
              data-testid={`bento-card-${s.id}`}
              className="group relative block h-[280px] sm:h-[320px] overflow-hidden rounded-3xl bg-charcoal transition-transform duration-500 ease-out hover:-translate-y-1.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal focus-visible:ring-offset-4 focus-visible:ring-offset-cream"
            >
              <img
                src={s.img.url}
                alt={s.img.alt}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover opacity-90 transition-transform duration-700 ease-out group-hover:scale-[1.06]"
              />
              <div
                className="absolute inset-0 bg-gradient-to-t from-charcoal/90 via-charcoal/35 to-charcoal/10 transition-opacity duration-500 group-hover:via-charcoal/25"
                aria-hidden="true"
              />
              <div className="absolute left-5 top-5 flex h-11 w-11 items-center justify-center rounded-full bg-cream/90 text-teal shadow-sm">
                <Icon size={20} strokeWidth={1.8} aria-hidden="true" />
              </div>
              <div className="absolute inset-x-0 bottom-0 p-5 sm:p-7">
                <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-sand/80">
                  {s.index} — Service
                </p>
                <h3 className="mt-2 font-serif text-3xl sm:text-4xl font-semibold text-cream tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-2 max-w-md text-sm text-cream/85">{s.promise}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-[0.2em] text-sand">
                  View
                  <ArrowUpRight
                    size={14}
                    className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                    aria-hidden="true"
                  />
                </span>
              </div>
            </Link>
          </motion.div>
        );
      })}
    </div>
  );
}
